const mapperGeneralCommentToApi = (form, userIdCommented) => {
    const { period, comment } = form

    return {
        period_id: period.value,
        user_id_commented: userIdCommented,
        comment,
    }
}

export { mapperGeneralCommentToApi }
